export const pickmeWebSite = "https://www.mypickme.com/"
export const zendeskLink = "https://mypickme.zendesk.com/hc/fr/requests/new?ticket_form_id=360003086832"
